/**
 * 관계 값 고르기 (spec 2026-09-18-calendar-properties §10): 대상 범위의 일정을 제목으로
 * 검색해(`GET /calendar/events/search`) 칩으로 고른다. people-picker 와 같은 팝오버 규약 —
 * 바깥 클릭·Esc 로 닫히고 ↑↓·Enter 로 고른다. `onChange(list)` 는 `[{id,title}]`.
 */
let current = null;
function el(tag, cls, text) { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

export function closeEventPicker() {
    if (!current) return;
    const done = current;
    current = null;
    done.root.remove();
    document.removeEventListener('mousedown', done.outside, true);
    document.removeEventListener('keydown', done.keys, true);
    // onClose(list): 고르기가 끝난 값 — 허브 셀처럼 한 번만 저장하는 쪽이 쓴다 (AY9)
    if (done.onClose) done.onClose(done.values());
}

export function openEventPicker(anchor, opts) {
    closeEventPicker();
    const o = Object.assign({ scope: 'me', multi: true, values: [], exclude: [], onChange: null, onClose: null, labels: {} }, opts || {});
    const L = Object.assign({ search: '일정 검색…', empty: '검색 결과 없음' }, o.labels);
    let values = (o.values || []).map((v) => (typeof v === 'string' ? { id: v, title: v } : { id: v.id, title: v.title || v.id, color: v.color || '' }));
    const pop = el('div', 'prop-pop ep-pop'); pop.setAttribute('role', 'listbox');
    const input = el('input'); input.type = 'text'; input.placeholder = L.search; input.autocomplete = 'off'; input.setAttribute('aria-label', L.search);
    const chips = el('div', 'pp-chips'); const list = el('div', 'pp-list ep-list');
    pop.appendChild(input); pop.appendChild(chips); pop.appendChild(list);
    document.body.appendChild(pop);
    const r = anchor.getBoundingClientRect();
    pop.style.position = 'fixed';
    pop.style.left = Math.max(8, Math.min(r.left, window.innerWidth - 330)) + 'px';
    pop.style.top = Math.min(r.bottom + 4, Math.max(8, window.innerHeight - 340)) + 'px';
    pop.style.zIndex = 'calc(var(--z-modal, 1000) + 20)';
    let rows = [], cursor = -1, seq = 0;
    function emit() { if (o.onChange) o.onChange(values.slice()); }
    function paintChips() {
        chips.innerHTML = '';
        values.forEach((v) => {
            const c = el('span', 'cal-share-chip'); c.appendChild(el('span', '', v.title));
            const x = el('button', '', '✕'); x.type = 'button'; x.setAttribute('aria-label', 'remove');
            x.addEventListener('click', () => { values = values.filter((w) => w.id !== v.id); paintChips(); emit(); search(); });
            c.appendChild(x); chips.appendChild(c);
        });
    }
    function choose(item) {
        if (o.multi) {
            if (values.some((v) => v.id === item.id)) values = values.filter((v) => v.id !== item.id);
            else values.push({ id: item.id, title: item.title, color: item.color || '' });
            paintChips(); emit(); search();
        } else {
            values = [{ id: item.id, title: item.title, color: item.color || '' }];
            emit(); closeEventPicker();
        }
    }
    function paint(items) {
        list.innerHTML = ''; rows = []; cursor = -1;
        if (!items.length) { list.appendChild(el('div', 'pp-empty text-muted', L.empty)); return; }
        items.forEach((it) => {
            const row = el('div', 'ep-row'); row.setAttribute('role', 'option'); row.dataset.id = it.id;
            row.appendChild(el('i', 'cal-dot cal-' + (it.color || 'c1')));
            row.appendChild(el('span', 'ep-title' + (it.done ? ' is-done' : ''), it.title));
            row.appendChild(el('span', 'ep-date', it.start || ''));
            if (values.some((v) => v.id === it.id)) row.setAttribute('aria-selected', 'true');
            row.addEventListener('mousedown', (e) => { e.preventDefault(); choose(it); });
            list.appendChild(row); rows.push({ el: row, item: it });
        });
    }
    function search() {
        const my = ++seq;
        const q = input.value.trim();
        const url = '/calendar/events/search?scope=' + encodeURIComponent(o.scope) + '&q=' + encodeURIComponent(q) + '&limit=20' + (o.exclude.length ? '&exclude=' + encodeURIComponent(o.exclude.join(',')) : '');
        fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then((res) => (res.ok ? res.json() : []))
            .then((items) => { if (my === seq) paint(items || []); })
            .catch(() => { if (my === seq) paint([]); });
    }
    let timer = null;
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(search, 200); });
    const keys = (e) => {
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeEventPicker(); if (anchor && anchor.focus) anchor.focus(); return; }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            if (!rows.length) return;
            cursor = (cursor + (e.key === 'ArrowDown' ? 1 : -1) + rows.length) % rows.length;
            rows.forEach((r2, i) => r2.el.classList.toggle('active', i === cursor));
            return;
        }
        if (e.key === 'Enter' && cursor >= 0) { e.preventDefault(); choose(rows[cursor].item); }
    };
    const outside = (e) => { if (!pop.contains(e.target) && e.target !== anchor && !anchor.contains(e.target)) closeEventPicker(); };
    document.addEventListener('mousedown', outside, true);
    document.addEventListener('keydown', keys, true);
    current = { root: pop, outside, keys, onClose: o.onClose, values: () => values.slice() };
    paintChips(); search(); input.focus();
}
